<!--服务器运维-->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ServerMaintain">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox clearfix">
          <el-input
            class="searchInput"
            placeholder="请输入服务器名称"
            v-model="serverData.paging.search_str"
            clearable>
          </el-input>
          <el-button
            class="searchBtn"
            type="primary"
            @click="getOperationList('search')">搜 索</el-button>
        </div>

        <!-- 服务器列表 -->
        <el-table
          v-loading="serverData.loading"
          :data="serverData.list">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline>
                <el-form-item label="用途">
                  <span>{{ props.row.server_use }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            class-name="textAlignLeft"
            prop="server_name"
            label="服务器名称"
            sortable>
          </el-table-column>
          <el-table-column
            label="上次操作时间">
            <template slot-scope="scope">
              <p class="text">{{scope.row.server_operation_date === '' ? '/' : scope.row.server_operation_date}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <p class="text">{{scope.row.server_operation_explain === '' ? '/' : scope.row.server_operation_explain}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="operateDialogInfo('operate', scope.row)">操作</el-button>
              <el-button type="text" @click="operateDialogInfo('record', scope.row)">记录</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="paging" v-if="serverData.pageCount > 1">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="serverData.paging.page"
            layout="prev, pager, next, jumper"
            :page-count="serverData.pageCount">
          </el-pagination>
        </div>

        <!--对话框-->
        <el-dialog
          :class="dialogData.type === 'record' ? 'dialogTable' : ''"
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">

          <!-- 操作 -->
          <div
            v-if="dialogData.type === 'operate'">
            <el-form
              label-width="80px"
              :model="dialogData.info">
              <el-form-item label="类型:">
                <div class="inputBox">
                  <el-select class="inputDeposit" v-model="dialogData.info.server_explain_type" placeholder="请选择">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="故障" value="2"></el-option>
                    <el-option label="其他" value="3"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <!-- 故障显示 -->
              <div v-if="dialogData.info.server_explain_type === '2'">
                <el-form-item label="处理时间:">
                  <div class="inputBox">
                    <el-date-picker
                      v-model="dialogData.info.server_debug_begin"
                      type="datetime"
                      placeholder="选择日期时间">
                    </el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="修复时间:">
                  <div class="inputBox">
                    <el-date-picker
                      v-model="dialogData.info.server_debug_end"
                      type="datetime"
                      placeholder="选择日期时间">
                    </el-date-picker>
                  </div>
                </el-form-item>
              </div>
              <!-- 故障，其他显示 -->
              <el-form-item label="备注:" v-if="dialogData.info.server_explain_type !== '1'">
                <div class="inputBox">
                  <el-input class="inputDeposit" type="textarea" rows="4" v-model="dialogData.info.server_operation_explain"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="addOperation">确 认</el-button>
              <el-button @click="dialogData.visible = false">取消</el-button>
            </div>
          </div>

          <!-- 记录 -->
          <div v-else>
            <!-- 记录列表 -->
            <el-table
              v-loading="recordData.loading"
              :data="recordData.list"
              style="width: 100%"
              border>
              <el-table-column
                type="index"
                label="序号"
                width="70">
              </el-table-column>
              <el-table-column
                prop="server_explain_type"
                label="类型">
                <template slot-scope="scope">
                  <p class="text">{{scope.row.server_explain_type === '1' ? '正常' : scope.row.server_explain_type === '2' ? '故障' : '其他'}}</p>
                </template>
              </el-table-column>
              <el-table-column
                label="处理时间"
                width="160">
                <template slot-scope="scope">
                  <p class="text">{{scope.row.server_debug_begin === null ? '/' : scope.row.server_debug_begin}}</p>
                </template>
              </el-table-column>
              <el-table-column
                label="修复时间"
                width="160">
                <template slot-scope="scope">
                  <p class="text">{{scope.row.server_debug_end === null ? '/' : scope.row.server_debug_end}}</p>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                width="220"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <p class="text">{{scope.row.server_operation_explain === '' ? '/' : scope.row.server_operation_explain}}</p>
                </template>
              </el-table-column>
              <el-table-column
                prop="server_operation_date"
                label="操作时间"
                width="160">
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging" v-if="recordData.pageCount > 1">
              <el-pagination
                @current-change="recordPageChange"
                :current-page.sync="recordData.paging.page"
                layout="prev, pager, next, jumper"
                :page-count="recordData.pageCount">
              </el-pagination>
            </div>
          </div>

        </el-dialog>
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { maintainApi } from "../../../../static/js/api.js"
  import { showToast } from '../../../../static/js/utility/utility'
import { getNowDate } from '../../../../static/js/utility/date';

  export default {
    name: 'ServerMaintain',
    components:{
      BreadCrumb
    },
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 服务器列表数据
        serverData: {
          // 分页数据  page为当前页，perPage为每页数量 ,search_str为搜索字段
          paging: {
            page: 1,
            perPage: 10,
            search_str: ''
          },
          // 服务器列表
          list: [],
          loading: false
        },
        // 记录列表数据
        recordData: {
          // 分页数据  page为当前页，perPage为每页数量 
          paging: {
            page: 1,
            perPage: 10
          },
          // 记录列表
          list: [],
          loading: false
        }
      }
    },
    mounted(){
      this.getOperationList()
    },
    created: async function () {
    },
    methods: {
      // 操作对话框信息（添加或修改）dialogData
      operateDialogInfo: function (type, info) {
        // 操作信息
        let operateInfo = {
          server_id: info.server_id ? info.server_id : '',
          server_explain_type: '1',
          server_debug_begin: '',
          server_debug_end: '',
          server_operation_explain: ''
        }

        this.dialogData = {
          type: type,
          title: type === 'operate' ? '操作' : type === 'record' ? '记录' : '',
          visible: !(this.dialogData.visible),
          isReset: false,
          info: type === 'operate' ? operateInfo : info
        }

        if (type === 'record') {
          this.getRecordList()
        }
        console.log('this', this.dialogData)
      },
      // 获取服务器列表 
      getOperationList: async function (search) {
        let vm = this
        let data = vm.serverData.paging
        if (search) {
          data.page = 1
        }
        
        vm.serverData.loading = true
        let res = await maintainApi.getOperationList(data)
        vm.serverData.loading = false
        if (res.meta.code === 200) {
          vm.serverData.list = res.data.list
          vm.serverData.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },
      // 服务器列表当前页值改变，获取新的服务器列表
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getOperationList()
      },
      // 操作
      addOperation: async function () {
        let vm = this
        let server_explain_type = vm.dialogData.info.server_explain_type
        let server_debug_begin = vm.dialogData.info.server_debug_begin
        let server_debug_end = vm.dialogData.info.server_debug_end
        let data = {
          server_id: vm.dialogData.info.server_id,
          server_explain_type: server_explain_type,
          server_debug_begin: server_debug_begin === '' ? '' : getNowDate(server_debug_begin),
          server_debug_end: server_debug_end === '' ? '' : getNowDate(server_debug_end),
          server_operation_explain: vm.dialogData.info.server_operation_explain
        }

        console.log('data', data)

        // 故障，其他判断
        if (server_explain_type !== '1') {
          // 故障判断
          if (server_explain_type === '2') {
            if (data.server_debug_begin === '') {
              showToast('请选择处理时间！')
              return
            }
            if (data.server_debug_end === '') {
              showToast('请选择修复时间！')
              return
            }
          }
          // 故障，其他判断
          if (data.server_operation_explain === '') {
            showToast('请填写备注！')
            return
          }
        }

        let res = await maintainApi.addOperation(data)
        if (res.meta.code === 200) {
          showToast('操作修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getOperationList()
        } else {
          showToast(res.meta.message)
        }

      },
      // 获取运维记录
      getRecordList: async function () {
        let vm = this
        let data = vm.recordData.paging
        data.server_id = vm.dialogData.info.server_id

        vm.recordData.loading = true
        let res = await maintainApi.getServerMaintainRecordList(data)
        vm.recordData.loading = false
        if (res.meta.code === 200) {
          vm.recordData.list = res.data.list
          vm.recordData.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },
      // 记录列表当前页值改变，获取新的记录列表
      recordPageChange(val) {
        console.log(`当前页: ${val}`);
        this.getRecordList()
      },
    },
    watch: {
      // 监听搜索字段的变化，被清空后，获取新的服务器列表
      "serverData.paging.search_str": function(newVal) {
        if (newVal === '') {
          this.getOperationList('search')
        }
      },
      // 监听操作类型变化,清空上一次填写信息
      'dialogData.info.server_explain_type': function (newVal) {
        console.log('当前类型', newVal)
        this.dialogData.info.server_debug_begin = ''
        this.dialogData.info.server_debug_end = ''
        this.dialogData.info.server_operation_explain = ''
      }
    }
  }
</script>

<style lang="scss" scoped>
.ServerMaintain {
  width: 100%;
  .searchBox {
    width: 100%;
    margin-bottom: 20px;
    .searchInput{
      width: 300px;
      float: left;
      margin-right: 30px;
    }
    .searchBtn {
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/Maintain/ServerMaintain.vue